var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.visible,"timeout":2000,"color":_vm.color,"top":"","transition":"fab-transition"}},[_c('v-row',{staticClass:"justify-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.content.toUpperCase()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }